
// EVALUATION-types
export const GET_EVALUATION_TYPES = "/evaluation-types";
export const ADD_NEW_EVALUATION_TYPE = "/evaluation-types";
export const UPDATE_EVALUATION_TYPE = "/evaluation-types";
export const DELETE_EVALUATION_TYPE = "/evaluation-types";

